import React from "react"

const SurveyBatchContext = React.createContext(null)

export default SurveyBatchContext
